import type { Entry } from 'contentful';

import { Image, ModalData } from '../models';
import { TypeModalSkeleton } from '../models/cms';

import { validateResponse } from '.';

export type ModalEntry = Entry<TypeModalSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>;

export const transformModal = (entry: ModalEntry): ModalData => {
  validateResponse(entry, ['ariaLabel', 'closeButtonAriaLabel', 'heading', 'image', 'paragraph', 'primaryButtonText', 'size']);
  const image = {
    title: entry.fields.image?.fields.title,
    description: entry.fields.image?.fields.description,
    url: entry.fields.image?.fields.file?.url,
  } as Image;

  return {
    id: entry.sys.id,
    ariaLabel: entry.fields.ariaLabel,
    closeButtonAriaLabel: entry.fields.closeButtonAriaLabel,
    heading: entry.fields.heading,
    image,
    paragraph: entry.fields.paragraph,
    primaryButtonText: entry.fields.primaryButtonText,
    primaryButtonHref: entry.fields.primaryButtonHref,
    publishedVersion: entry.sys.publishedVersion.toString(),
    secondaryButtonText: entry.fields.secondaryButtonText,
    secondaryButtonHref: entry.fields.secondaryButtonHref,
    size: entry.fields.size,
  };
};
